Collection.prototype.getProducts = function (pageNumber) {

  var getProducts;
  var start;
  var end;

  // FILTER PRODUCTS
  var filteredProducts =
    this.filterHelpers().filterProducts(
      this.allProducts,
      this.params.filterOptions
    );

  // KEEP ALL PRODUCTS
  getProducts = filteredProducts;

  // NORMAL SORTING
  this.sortProducts(getProducts);

  // SPLIT STOCK / OOS
  const inStockProducts =
    getProducts.filter(function (p) {
      return p.available;
    });

  const oosProducts =
    getProducts.filter(function (p) {
      return !p.available;
    });

  // TOTAL STOCK PAGES
  const stockPages =
    Math.ceil(
      inStockProducts.length /
      this.options.productPerPage
    );

  // BEFORE LAST PAGE
  if (pageNumber < stockPages) {

    getProducts = inStockProducts;

  }

  // LAST PAGE
  else {

    getProducts = [
      ...inStockProducts,
      ...oosProducts
    ];

  }

  // TOTAL PAGE UPDATE
  this.totalPage = Math.ceil(
    getProducts.length /
    this.options.productPerPage
  );

  // PAGINATION
  start =
    (pageNumber - 1) *
    this.options.productPerPage;

  end =
    start +
    this.options.productPerPage;

  return getProducts.slice(start, end);

};